import "./skeleton.css"
export default function Skeleton (){
    return(
        <div class="description">
            <div class="line line-2"></div>
        </div>
    
    )
}